import { uploadImageAPI } from "@src/api/raffle-draw";
import { homepageAPI, homePageDetailsAPI } from "@src/api/rewards-management";
import { usePartnerDropdownContext } from "@src/context/PartnerDropdown";
import { useToasterContext } from "@src/context/Toaster";
import { UseHomePageEditorServiceOperators } from "@src/lib/types/home-page-editor";
import { AlertType } from "@src/lib/types/toaster";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useServices = (): Readonly<UseHomePageEditorServiceOperators> => {
  const { triggerOpen } = useToasterContext();
  const { state: { selectedPartnerId } } = usePartnerDropdownContext();

  const { data, isLoading } = useQuery({
    queryKey: ["home-page-content", {selectedPartnerId}],
    queryFn: async () => {
      const result = await homePageDetailsAPI({ partnerId: selectedPartnerId });

      return result;
    },
  });

  const onPublish = useMutation({
    mutationKey: ['publish-content', {selectedPartnerId}],
    mutationFn: async (params?: Partial<any>) => {
      const result = await homepageAPI({ ...params, partnerId: selectedPartnerId });
      return result;
    },
    onError: (error) => {
      triggerOpen({
        type: AlertType.error,
        title: "Publish Content",
        message: "Failed to publish.",
      });
    },
  });

  const uploadImage = useMutation({
    mutationKey: ['upload-image'],
    mutationFn: async (params?: Partial<any>) => {
      const result = await uploadImageAPI(params);
      return {
        type: params?.get("type"),
        result: result?.data ?? {}
      };
    },
    onError: (error) => {
      triggerOpen({
        type: AlertType.error,
        title: "Uploading Image",
        message: "Failed to upload image.",
      });
    },
  });

  return {
    data,
    isLoading,
    uploadImage,
    onPublish
  };
};
